import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { renderWhenNotNil } from '../../shared/utils/rendering';
import { Experience } from '../experience';

export class MarketExperience extends PureComponent {
  static propTypes = {
    fetchMarket: PropTypes.func.isRequired,
    setCurrentMarketBySlug: PropTypes.func.isRequired,
    match: PropTypes.object,
    currentMarketId: PropTypes.string,
  };

  componentDidMount() {
    this.props.fetchMarket(this.props.match.params.marketSlug);
  }

  componentWillUnmount() {
    this.props.setCurrentMarketBySlug(null);
  }

  render = () => renderWhenNotNil(() => <Experience />)(this.props.currentMarketId);
}
